export const BUILD_VERSION = '1779298536';
